import React from "react";
import { makeStyles } from "@material-ui/styles";
import { useHistory } from "react-router-dom";
import menu from "./menu.json";

const useStyles = makeStyles({
  container: {
    minWidth: 40,
    height: 25,
    display: "flex",
    backgroundImage: `url(/images/upkp/Humberbar.svg)`,
    backgroundRepeat: "no-repeat",
    cursor: "pointer",
    position: "relative",
  },
  menu: {
    position: "absolute",
    paddingTop: 20,
    top: 40,
    zIndex: 99,
    backgroundColor: `rgb(255,255,255, 1)`,
    minWidth: 220,
    padding: 8,
    borderRadius: "0px 0px 8px 8px",
  },
  ul: {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  li: {
    height: 24,
    display: "flex",
    marginBottom: 8,
    "&:hover": {
      fontWeight: "600",
    },
  },
  numbering: {
    fontSize: 10,
    verticalAlign: "sub",
    width: 14,
    paddingTop: 4,
  },
  name: {
    fontSize: 18,
    fontWeight: "600",
  },
});

export default function () {
  const classes = useStyles();
  const [showMenu, setShowMenu] = React.useState(false);
  const history = useHistory();

  const handleMenuClick = (url) => () => {
    history.push(url);
  };

  const menuAddHome = [{ name: "Home", url: "/" }, ...menu];

  const menuRenderer = menuAddHome.map((m, i) => (
    <li className={classes.li} key={m.url} onClick={handleMenuClick(m.url)}>
      <span className={classes.numbering}>0{i + 1}</span>
      <span className={classes.name}>{m.name}</span>
    </li>
  ));

  const handleClick = () => {
    setShowMenu(!showMenu);
  };

  React.useEffect(() => {
    const hideMenu = (e) => {
      const targetId = e?.target?.id;
      if (targetId !== "toggleMenuButton") {
        setShowMenu(false);
      }
    };

    window.addEventListener("click", hideMenu);

    return () => window.removeEventListener("click", hideMenu);
  }, []);

  return (
    <div
      className={classes.container}
      onClick={handleClick}
      id="toggleMenuButton"
    >
      {showMenu && (
        <div className={classes.menu}>
          <ol className={classes.ul}>{menuRenderer}</ol>
        </div>
      )}
    </div>
  );
}
